export const GET_CAMPAIGN_REQUEST = 'get_campaign_request';
export const GET_CAMPAIGN_SUCCESS = 'get_campaign_success';
export const GET_CAMPAIGN_FAILURE = 'get_campaign_failure';